import { Component, OnInit } from '@angular/core';
import { RentalsService } from '../../../../../services/rentals.service';
import { HelpersService } from '../../../../../services/helpers.service';
import { PaymentService } from '../../../../../services/payment.service';
import { ProductsService } from '../../../../../services/products.service';
import { PosIntegrationService } from '../../../../../services/pos-integration.service';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import moment from 'moment';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-rentals-configuration',
  templateUrl: './rentals-configuration.component.html',
  styleUrls: ['./rentals-configuration.component.scss'],
  providers: [MessageService],
})
export class RentalsConfigurationComponent implements OnInit {
  public partner: any = {};
  public isStipeIntegrated: boolean = false;
  public isPaystackIntegrated: boolean = false;
  public isSquareIntegrated: boolean = false;
  public isPOSPaymentsSupported: boolean = false;
  public configuaration: any = {};
  public RentalConfigForm: FormGroup;
  public busy: boolean = false;
  public products: any = [];
  public searchResult: any = [];
  public newSku: any = {};
  public canEdit = true;

  timeUnits = [
    { label: 'Hours', value: 'hours' },
    { label: 'Minutes', value: 'minutes' }
  ];

  public modules = {
    toolbar: [
      ['bold', 'italic', 'underline'], // toggled buttons
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
      ['clean'], // remove formatting button
    ],
  };

  constructor(
    private fb: FormBuilder,
    private rentalsService: RentalsService,
    private helpersService: HelpersService,
    private messageService: MessageService,
    private paymentService: PaymentService,
    private posIntegrationService: PosIntegrationService,
    private productsService: ProductsService,
    private translate: TranslateService,
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    if (
      this.partner.StripePayoutId &&
      this.partner.StripePayoutId.indexOf('acct_') > 1
    ) {
      this.isStipeIntegrated = true;
    }
    if (this.partner.CanDoSquare)
      console.log(this.partner);
    this.newSku = null;
    this.getConfiguration();
    this.checkIfLinkedToStripeConnect();
    this.checkIfLinkedToPaystack();
    this.checkIfLinkedToSquare();
  }

  getConfiguration() {
    this.rentalsService
      .getRentalConfiguration(this.helpersService.getPartnerId())
      .subscribe((configuaration) => {
        this.configuaration = configuaration;
        this.configuaration.defaultStoreTimes.forEach((x) => {
          if (x.startTime != null && x.startTime.length === 8) {
            x.startTime = moment('1970-01-01T' + x.startTime).toDate();
          }
          if (x.endTime != null && x.endTime.length === 8) {
            x.endTime = moment('1970-01-01T' + x.endTime).toDate();
          }
        });
        this.setupValidation();

        //if (this.configuaration.addBookingFee) {
        //  this.posIntegrationService
        //    .getPartnerPOSConfiguration(this.helpersService.getPartnerId())
        //    .subscribe(
        //      (config) => {
        //        console.log('POS Config', config);
        //        console.log('Partner', this.partner);
        //        if (config.UseSquarePayments || this.partner.POSSystemID === 17) {
        //          this.canEdit = false;
        //          this.RentalConfigForm.controls['bookingFeePercentOrFixed'].setValue('PERCENT');
        //          this.RentalConfigForm.controls['bookingFeeValue'].setValue(100);
        //          this.RentalConfigForm.controls['bookingFeeValue'].disable();
        //        }
        //      });
        //}

      });


  }

  handleAddBookingFeee(event) {
    if (event) {
      if (this.partner.POSSystemID === 17) {
        if (event.checked) {
          this.posIntegrationService
            .getPartnerPOSConfiguration(this.helpersService.getPartnerId())
            .subscribe(
              (config) => {
                console.log('POS Config', config);
                console.log('Partner', this.partner);
                if (config.UseSquarePayments || this.partner.POSSystemID === 17) {
                  this.canEdit = false;
                  this.RentalConfigForm.controls['bookingFeePercentOrFixed'].setValue('PERCENT');
                  this.RentalConfigForm.controls['bookingFeeValue'].setValue(100);
                  this.RentalConfigForm.controls['bookingFeeValue'].disable();
                }
              });
        }
      }
    }
  }

  setupValidation() {
    this.RentalConfigForm = this.fb.group({
      maxRentalsPerDay: new FormControl(this.configuaration.maxRentalsPerDay, [
        Validators.required,
        Validators.min(1),
      ]),
      maxProductsOutAnyGivenTime: new FormControl(
        this.configuaration.maxProductsOutAnyGivenTime,
        [Validators.required, Validators.min(1)],
      ),
      bufferMinutesBetweenRentals: new FormControl(
        this.configuaration.bufferMinutesBetweenRentals,
        [Validators.required, Validators.min(0)],
      ),
      staggerMinutesInterval: new FormControl(
        this.configuaration.staggerMinutesInterval,
        [Validators.required, Validators.min(0)],
      ),
      maxRentalsSameSlot: new FormControl(
        this.configuaration.maxRentalsSameSlot,
        [Validators.required, Validators.min(1)],
      ),
      calendarDayViewInterval: new FormControl(
        this.configuaration.calendarDayViewInterval,
        Validators.required,
      ),
      calendarWeekViewInterval: new FormControl(
        this.configuaration.calendarWeekViewInterval,
        Validators.required,
      ),
      calendarMonthViewInterval: new FormControl(
        this.configuaration.calendarMonthViewInterval,
        Validators.required,
      ),
      waiverRequired: new FormControl(
        this.configuaration.waiverRequired,
        Validators.required,
      ),
      waiverTerms: new FormControl(
        this.configuaration.waiverTerms,
        Validators.nullValidator,
      ),
      cancellationPolicy: new FormControl(
        this.configuaration.cancellationPolicy,
        Validators.nullValidator,
      ),
      paymentOnCheckout: new FormControl(
        this.configuaration.paymentOnCheckout,
        Validators.required,
      ),
      fullPaymentOrDeposit: new FormControl(
        this.configuaration.fullPaymentOrDeposit,
        Validators.nullValidator,
      ),
      depositPercentOrFixed: new FormControl(
        this.configuaration.depositPercentOrFixed,
        Validators.nullValidator,
      ),
      depositValue: new FormControl(
        this.configuaration.depositValue,
        Validators.nullValidator,
      ),
      sendNotificationOnRental: new FormControl(
        this.configuaration.sendNotificationOnRental || false,
        Validators.nullValidator,
      ),
      rentalNotificationsAddresses: new FormControl(
        this.configuaration.rentalNotificationsAddresses,
        Validators.nullValidator,
      ),
      deductSecurityDeposit: new FormControl(
        this.configuaration.deductSecurityDeposit || false,
        Validators.required,
      ),
      hoursBeforeReservationToDeductSecurityDeposit: new FormControl(
        this.configuaration.hoursBeforeReservationToDeductSecurityDeposit,
        Validators.required,
      ),
      allowFixedRentalOptions: new FormControl(
        this.configuaration.allowFixedRentalOptions || false,
        Validators.required,
      ),
      allowFlexibleRentalOptions: new FormControl(
        this.configuaration.allowFlexibleRentalOptions || false,
        Validators.required,
      ),
      addBookingFee: new FormControl(
        this.configuaration.addBookingFee || false,
        Validators.required,
      ),
      bookingFeePercentOrFixed: new FormControl(
        this.configuaration.bookingFeePercentOrFixed,
        Validators.nullValidator,
      ),
      bookingFeeValue: new FormControl(
        this.configuaration.bookingFeeValue,
        Validators.nullValidator,
      ),
      bookingFeeInternalProductID: new FormControl(
        this.configuaration.bookingFeeInternalProductID,
        Validators.nullValidator,
      ),

      reservationTimeUnit_BeforeStartReminder: new FormControl(
        this.configuaration.reservationTimeUnit_BeforeStartReminder || 'hours',
        Validators.required,
      ),
      reservationTimeValue_BeforeStartReminder: new FormControl(
        this.configuaration.reservationTimeValue_BeforeStartReminder || 1,
        Validators.required,
      ),

      reservationTimeUnit_BeforeReturnReminder: new FormControl(
        this.configuaration.reservationTimeUnit_BeforeReturnReminder || 'hours',
        Validators.required,
      ),
      reservationTimeValue_BeforeReturnReminder: new FormControl(
        this.configuaration.reservationTimeValue_BeforeReturnReminder || 1,
        Validators.required,
      ),

      reservationTimeUnit_AfterReturnOverdueReminder: new FormControl(
        this.configuaration.reservationTimeUnit_AfterReturnOverdueReminder || 'hours',
        Validators.required,
      ),
      reservationTimeValue_AfterReturnOverdueReminder: new FormControl(
        this.configuaration.reservationTimeValue_AfterReturnOverdueReminder || 1,
        Validators.required,
      ),

      availabilityBufferDays: new FormControl(
        this.configuaration.availabilityBufferDays,
        Validators.required,
      ),
      showBarCodeOnPrint: new FormControl(
        this.configuaration.showBarCodeOnPrint,
        Validators.required,
      ),
      showQRCodeOnPrint: new FormControl(
        this.configuaration.showQRCodeOnPrint,
        Validators.required,
      ),
    });

    this.RentalConfigForm.get('paymentOnCheckout').valueChanges.subscribe(
      (value) => {
        if (value) {
          this.RentalConfigForm.get('fullPaymentOrDeposit').setValidators(
            Validators.required,
          );
        } else {
          this.RentalConfigForm.get('fullPaymentOrDeposit').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('depositPercentOrFixed').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('depositValue').setValidators(
            Validators.nullValidator,
          );
        }
      },
    );
    this.RentalConfigForm.get('fullPaymentOrDeposit').valueChanges.subscribe(
      (value) => {
        if (value === 'DEPOSIT') {
          this.RentalConfigForm.get('depositPercentOrFixed').setValidators(
            Validators.required,
          );
          this.RentalConfigForm.get('depositValue').setValidators(
            Validators.required,
          );
        } else {
          this.RentalConfigForm.get('depositPercentOrFixed').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('depositValue').setValidators(
            Validators.nullValidator,
          );
        }
      },
    );
    this.RentalConfigForm.get('depositPercentOrFixed').valueChanges.subscribe(
      (value) => {
        if (value) {
          this.RentalConfigForm.get('depositValue').setValidators(
            Validators.required,
          );
        } else {
          this.RentalConfigForm.get('depositValue').setValidators(
            Validators.nullValidator,
          );
        }
      },
    );

    this.RentalConfigForm.get('addBookingFee').valueChanges.subscribe(
      (value) => {
        console.log(value);
        if (value) {
          this.RentalConfigForm.get('bookingFeePercentOrFixed').setValidators(
            Validators.required,
          );
          this.RentalConfigForm.get(
            'bookingFeeInternalProductID',
          ).setValidators(Validators.required);
          this.RentalConfigForm.get('bookingFeeValue').setValidators([
            Validators.required,
            Validators.min(1),
          ]);
        } else {
          this.RentalConfigForm.get('bookingFeePercentOrFixed').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get('bookingFeeValue').setValidators(
            Validators.nullValidator,
          );
          this.RentalConfigForm.get(
            'bookingFeeInternalProductID',
          ).setValidators(Validators.nullValidator);
        }
        console.log(this.RentalConfigForm);
      },
    );
  }

  checkIfLinkedToStripeConnect() {
    this.paymentService
      .checkPartnerLinkedStripeConnect(this.partner.ID)
      .subscribe(
        (result) => {
          this.isStipeIntegrated = result && result.linked;
          this.checkPOSPaymentsSupported();
        },
        (error) => {
          this.isStipeIntegrated = false;
          this.checkPOSPaymentsSupported();
        },
      );
  }

  checkIfLinkedToSquare() {
    this.paymentService
      .getPartnerPOSConfiguration(this.helpersService.getPartnerId())
      .subscribe(
        (config) => {
          if (config.UseSquarePayments) {
            this.isSquareIntegrated = true;
          }
        },
        (err) => {
          this.checkPOSPaymentsSupported();
        },
      );
  }

  checkIfLinkedToPaystack() {
    this.paymentService
      .getPartnerPaystackConfig(this.helpersService.getPartnerId())
      .subscribe(
        (config) => {
          if (config.linked && config.paystackSecretKey) {
            this.isPaystackIntegrated = true;
            this.checkPOSPaymentsSupported();
          }
        },
        (err) => {
          this.checkPOSPaymentsSupported();
        },
      );
  }

  checkPOSPaymentsSupported() {
    if (this.partner.POSSystemID == 6 || this.partner.POSSystemID == 3 || this.partner.POSSystemID == 12 || this.partner.POSSystemID == 19 || this.partner.POSSystemID == 17) {
      this.isPOSPaymentsSupported = true;
    } else if (this.partner.POSSystemID == 9) {
      this.posIntegrationService.getShopifyConfig(this.partner.ID).subscribe(res => {
        if (!res.UseDraftOrders) {
          this.isPOSPaymentsSupported = true;
        } else {
          this.isPOSPaymentsSupported = false;
        }
      });
    } else if (this.partner.POSSystemID !== 6 && this.partner.POSSystemID !== 3 && this.partner.POSSystemID !== 9 && this.partner.POSSystemID !== 12 && this.isStipeIntegrated) {
      this.isPOSPaymentsSupported = true;
    } else if (this.partner.POSSystemID <= 0) {
      this.isPOSPaymentsSupported = true;
    }
    else {
      this.isPOSPaymentsSupported = false;
    }
  }

  saveConfig(data) {
    this.busy = true;
    let update = {
      ...this.configuaration,
      ...data,
      defaultStoreTimes: [],
      overrideStoreTimes: [],
    };

    if (!update.paymentOnCheckout) {
      update.deductSecurityDeposit = false;
    }

    this.rentalsService.updateRentalConfig(update).subscribe(
      (partner) => {
        this.busy = false;
        this.messageService.add({
          life: 5000,
          detail: this.translate.instant(
            'bikeshop.service_deposit_configuration.updated_configuration',
          ),
          closable: false,
        });
      },
      (err) => {
        this.busy = false;
      },
    );
  }

  getFormData() {
    console.log(this.RentalConfigForm);
  }

  linkSku(sku) {
    this.RentalConfigForm.get('bookingFeeInternalProductID').setValue(sku.ID);
    this.configuaration.bookingFeeInternalProductID = sku.ID;
    this.configuaration.bookingFeeSKU = sku.SKU;
    this.configuaration.bookingFeeName = sku.Name;
    this.newSku = null;
  }

  removeSKU() {
    this.RentalConfigForm.get('bookingFeeInternalProductID').setValue(null);
    this.configuaration.bookingFeeInternalProductID = null;
    this.configuaration.bookingFeeSKU = null;
    this.configuaration.bookingFeeName = null;
    this.newSku = null;
  }

  searchProducts(event) {
    var results = this.products.filter(function (product) {
      return (
        product.SKU.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        product.Name.toLowerCase().indexOf(event.query.toLowerCase()) > -1 ||
        (product.SystemSKU !== null &&
          product.SystemSKU.toLowerCase().indexOf(event.query.toLowerCase()) >
          -1) ||
        (product.ManufacturerSKU !== null &&
          product.ManufacturerSKU.toLowerCase().indexOf(
            event.query.toLowerCase(),
          ) > -1)
      );
    });
    results = JSON.parse(JSON.stringify(results)).map((product) => {
      product.InternalProductID = JSON.parse(JSON.stringify(product)).ID;
      product.ID = 0;
      product.Quantity = 1;
      delete product.PartnerID;
      return product;
    });

    if (results.length > 0) {
      this.searchResult = results;
    } else {
      this.searchExternal(event);
    }
  }

  searchExternal(event) {
    this.productsService
      .searchProduct(this.helpersService.getPartnerId(), event.query)
      .subscribe((results) => {
        this.searchResult = results.map((item) => {
          return {
            ID: item.ID,
            SKU: item.Description,
            Name: item.Data,
            Quantity: 1,
          };
        });
      });
  }
}
